// Shared resource types.
//
// Field order fixes tag order, exactly as Section 15 of CHAT-SPEC.md lists it.
// Identifiers are 16 raw bytes, never a formatted string. Timestamps are Unix
// milliseconds UTC as int64: a client that rounds one through a JavaScript
// Number loses precision above 2^53, so generated TypeScript uses bigint.

// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file chat/v1/common.proto (package chat.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file chat/v1/common.proto.
 */
export const file_chat_v1_common: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * Commit is returned by every persisted mutation, including every successful
 * retry of one. Retrying a committed operation returns the original metadata
 * rather than performing the work again.
 *
 * @generated from message chat.v1.Commit
 */
export type Commit = Message$1<"chat.v1.Commit"> & {
  /**
   * @generated from field: bytes operation_id = 1;
   */
  operationId: Uint8Array;

  /**
   * @generated from field: bytes entity_id = 2;
   */
  entityId: Uint8Array;

  /**
   * @generated from field: optional int64 conversation_seq = 3;
   */
  conversationSeq?: bigint | undefined;

  /**
   * @generated from field: int64 entity_version = 4;
   */
  entityVersion: bigint;

  /**
   * @generated from field: int64 committed_at = 5;
   */
  committedAt: bigint;
};

/**
 * Describes the message chat.v1.Commit.
 * Use `create(CommitSchema)` to create a new message.
 */
export const CommitSchema: GenMessage<Commit> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 0);

/**
 * Error is the single failure shape. The message is bounded and safe: it never
 * discloses whether an account or a conversation exists.
 *
 * @generated from message chat.v1.Error
 */
export type Error = Message$1<"chat.v1.Error"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @generated from field: string message = 2;
   */
  message: string;

  /**
   * @generated from field: bool retryable = 3;
   */
  retryable: boolean;

  /**
   * @generated from field: optional uint32 retry_after_ms = 4;
   */
  retryAfterMs?: number | undefined;

  /**
   * Present on a version conflict: the version the actor is currently
   * permitted to see, so a client can reconcile without another round trip.
   *
   * @generated from field: optional int64 current_version = 5;
   */
  currentVersion?: bigint | undefined;
};

/**
 * Describes the message chat.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema: GenMessage<Error> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 1);

/**
 * Entity marks a range of message text. Offsets and lengths count Unicode
 * scalar values, not UTF-16 code units, so a client that measures in UTF-16
 * must convert rather than assume.
 *
 * @generated from message chat.v1.Entity
 */
export type Entity = Message$1<"chat.v1.Entity"> & {
  /**
   * @generated from field: chat.v1.Entity.Kind kind = 1;
   */
  kind: Entity_Kind;

  /**
   * @generated from field: uint32 offset = 2;
   */
  offset: number;

  /**
   * @generated from field: uint32 length = 3;
   */
  length: number;

  /**
   * The link target, custom emoji reference, or the canonical user identifier
   * a mention points at.
   *
   * @generated from field: optional string value = 4;
   */
  value?: string | undefined;
};

/**
 * Describes the message chat.v1.Entity.
 * Use `create(EntitySchema)` to create a new message.
 */
export const EntitySchema: GenMessage<Entity> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 2);

/**
 * @generated from enum chat.v1.Entity.Kind
 */
export enum Entity_Kind {
  /**
   * @generated from enum value: KIND_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: KIND_BOLD = 1;
   */
  BOLD = 1,

  /**
   * @generated from enum value: KIND_ITALIC = 2;
   */
  ITALIC = 2,

  /**
   * @generated from enum value: KIND_CODE = 3;
   */
  CODE = 3,

  /**
   * @generated from enum value: KIND_PRE = 4;
   */
  PRE = 4,

  /**
   * @generated from enum value: KIND_UNDERLINE = 5;
   */
  UNDERLINE = 5,

  /**
   * @generated from enum value: KIND_STRIKE = 6;
   */
  STRIKE = 6,

  /**
   * @generated from enum value: KIND_LINK = 7;
   */
  LINK = 7,

  /**
   * @generated from enum value: KIND_SPOILER = 8;
   */
  SPOILER = 8,

  /**
   * @generated from enum value: KIND_CUSTOM_EMOJI = 9;
   */
  CUSTOM_EMOJI = 9,

  /**
   * @generated from enum value: KIND_MENTION = 10;
   */
  MENTION = 10,
}

/**
 * Describes the enum chat.v1.Entity.Kind.
 */
export const Entity_KindSchema: GenEnum<Entity_Kind> = /*@__PURE__*/
  enumDesc(file_chat_v1_common, 2, 0);

/**
 * @generated from message chat.v1.Attachment
 */
export type Attachment = Message$1<"chat.v1.Attachment"> & {
  /**
   * @generated from field: bytes media_id = 1;
   */
  mediaId: Uint8Array;

  /**
   * @generated from field: optional string caption = 2;
   */
  caption?: string | undefined;

  /**
   * @generated from field: optional uint32 width = 3;
   */
  width?: number | undefined;

  /**
   * @generated from field: optional uint32 height = 4;
   */
  height?: number | undefined;

  /**
   * @generated from field: optional uint32 duration_ms = 5;
   */
  durationMs?: number | undefined;

  /**
   * @generated from field: optional string filename = 6;
   */
  filename?: string | undefined;

  /**
   * @generated from field: int64 size_bytes = 7;
   */
  sizeBytes: bigint;

  /**
   * @generated from field: string mime = 8;
   */
  mime: string;

  /**
   * A short-lived scoped grant proving the sender may attach this object. It is
   * excluded from the canonical payload hash, so refreshing an expired
   * capability does not change the operation's identity.
   *
   * @generated from field: optional bytes capability = 9;
   */
  capability?: Uint8Array | undefined;
};

/**
 * Describes the message chat.v1.Attachment.
 * Use `create(AttachmentSchema)` to create a new message.
 */
export const AttachmentSchema: GenMessage<Attachment> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 3);

/**
 * @generated from message chat.v1.Content
 */
export type Content = Message$1<"chat.v1.Content"> & {
  /**
   * @generated from field: chat.v1.Content.Kind kind = 1;
   */
  kind: Content_Kind;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: repeated chat.v1.Entity entities = 3;
   */
  entities: Entity[];

  /**
   * @generated from field: repeated chat.v1.Attachment attachments = 4;
   */
  attachments: Attachment[];

  /**
   * @generated from field: optional bytes reply_to = 5;
   */
  replyTo?: Uint8Array | undefined;

  /**
   * @generated from field: optional bytes topic_id = 6;
   */
  topicId?: Uint8Array | undefined;

  /**
   * Identifies the poll, checklist, location or contact record created
   * atomically with this message.
   *
   * @generated from field: optional bytes embedded_id = 7;
   */
  embeddedId?: Uint8Array | undefined;
};

/**
 * Describes the message chat.v1.Content.
 * Use `create(ContentSchema)` to create a new message.
 */
export const ContentSchema: GenMessage<Content> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 4);

/**
 * @generated from enum chat.v1.Content.Kind
 */
export enum Content_Kind {
  /**
   * @generated from enum value: KIND_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: KIND_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: KIND_PHOTO = 2;
   */
  PHOTO = 2,

  /**
   * @generated from enum value: KIND_VIDEO = 3;
   */
  VIDEO = 3,

  /**
   * @generated from enum value: KIND_FILE = 4;
   */
  FILE = 4,

  /**
   * @generated from enum value: KIND_VOICE = 5;
   */
  VOICE = 5,

  /**
   * @generated from enum value: KIND_VIDEO_NOTE = 6;
   */
  VIDEO_NOTE = 6,

  /**
   * @generated from enum value: KIND_ALBUM = 7;
   */
  ALBUM = 7,

  /**
   * @generated from enum value: KIND_POLL = 8;
   */
  POLL = 8,

  /**
   * @generated from enum value: KIND_CHECKLIST = 9;
   */
  CHECKLIST = 9,

  /**
   * @generated from enum value: KIND_LOCATION = 10;
   */
  LOCATION = 10,

  /**
   * @generated from enum value: KIND_CONTACT = 11;
   */
  CONTACT = 11,

  /**
   * @generated from enum value: KIND_SYSTEM = 12;
   */
  SYSTEM = 12,
}

/**
 * Describes the enum chat.v1.Content.Kind.
 */
export const Content_KindSchema: GenEnum<Content_Kind> = /*@__PURE__*/
  enumDesc(file_chat_v1_common, 4, 0);

/**
 * Origin attributes a forwarded message. It is populated only when the source
 * permits attribution; otherwise the copy carries no origin identifiers at all
 * rather than a redacted placeholder that would still leak that a source
 * existed.
 *
 * @generated from message chat.v1.Origin
 */
export type Origin = Message$1<"chat.v1.Origin"> & {
  /**
   * @generated from field: optional bytes conversation_id = 1;
   */
  conversationId?: Uint8Array | undefined;

  /**
   * @generated from field: optional bytes message_id = 2;
   */
  messageId?: Uint8Array | undefined;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;
};

/**
 * Describes the message chat.v1.Origin.
 * Use `create(OriginSchema)` to create a new message.
 */
export const OriginSchema: GenMessage<Origin> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 5);

/**
 * @generated from message chat.v1.Message
 */
export type Message = Message$1<"chat.v1.Message"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: bytes conversation_id = 2;
   */
  conversationId: Uint8Array;

  /**
   * Fixed at creation. An edit advances version and never moves the message in
   * history.
   *
   * @generated from field: int64 created_seq = 3;
   */
  createdSeq: bigint;

  /**
   * @generated from field: bytes sender_id = 4;
   */
  senderId: Uint8Array;

  /**
   * @generated from field: int64 version = 5;
   */
  version: bigint;

  /**
   * @generated from field: optional chat.v1.Content content = 6;
   */
  content?: Content | undefined;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt: bigint;

  /**
   * @generated from field: optional int64 edited_at = 8;
   */
  editedAt?: bigint | undefined;

  /**
   * A deleted message keeps its identifier and sequence position as a
   * tombstone, so a late replay cannot resurrect its content.
   *
   * @generated from field: bool deleted = 9;
   */
  deleted: boolean;

  /**
   * @generated from field: optional chat.v1.Origin forward_origin = 10;
   */
  forwardOrigin?: Origin | undefined;

  /**
   * Set on a channel post, on the discussion anchor that stands for it, and on
   * a comment whose thread hangs off that anchor. A comment cannot carry the
   * reference itself — reply_to means a message in the same conversation, and a
   * post lives in a different one — so the pairing is its own resource.
   *
   * @generated from field: optional chat.v1.PostDiscussionLink discussion = 11;
   */
  discussion?: PostDiscussionLink | undefined;

  /**
   * Who this message is displayed as. Present on every message a 1.1 client
   * receives, and the only field a client should read for attribution.
   *
   * sender_id at tag 4 predates it and cannot express a channel: it is a bare
   * UUID with no kind, so a channel identifier placed there would be
   * indistinguishable from an account. That is why this field exists.
   *
   * @generated from field: optional chat.v1.SenderIdentity sender = 12;
   */
  sender?: SenderIdentity | undefined;
};

/**
 * Describes the message chat.v1.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 6);

/**
 * PostDiscussionLink pairs a channel post with the comment thread created for
 * it.
 *
 * All four identifiers are required whenever the resource is present. A partial
 * link is not a weaker link, it is an unusable one: a client that cannot name
 * both endpoints cannot navigate in either direction, and a half-populated
 * resource would have it try.
 *
 * @generated from message chat.v1.PostDiscussionLink
 */
export type PostDiscussionLink = Message$1<"chat.v1.PostDiscussionLink"> & {
  /**
   * @generated from field: bytes channel_id = 1;
   */
  channelId: Uint8Array;

  /**
   * @generated from field: bytes post_message_id = 2;
   */
  postMessageId: Uint8Array;

  /**
   * @generated from field: bytes discussion_group_id = 3;
   */
  discussionGroupId: Uint8Array;

  /**
   * @generated from field: bytes anchor_message_id = 4;
   */
  anchorMessageId: Uint8Array;
};

/**
 * Describes the message chat.v1.PostDiscussionLink.
 * Use `create(PostDiscussionLinkSchema)` to create a new message.
 */
export const PostDiscussionLinkSchema: GenMessage<PostDiscussionLink> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 7);

/**
 * SenderIdentity is the identity a message is displayed under.
 *
 * The subject is a choice between an account and a channel rather than a UUID
 * plus a flag, so a message cannot describe itself as both or as neither.
 * Exactly one is populated.
 *
 * A channel subject names a CHANNEL conversation. It is not an account and has
 * no account row: resolving it means reading the channel, which is why the kind
 * travels with the identifier and a client must cache by kind and UUID together
 * rather than by UUID alone.
 *
 * @generated from message chat.v1.SenderIdentity
 */
export type SenderIdentity = Message$1<"chat.v1.SenderIdentity"> & {
  /**
   * @generated from oneof chat.v1.SenderIdentity.subject
   */
  subject: {
    /**
     * @generated from field: bytes user_id = 1;
     */
    value: Uint8Array;
    case: "userId";
  } | {
    /**
     * @generated from field: bytes channel_id = 2;
     */
    value: Uint8Array;
    case: "channelId";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * Absent when the subject has no avatar. A channel currently never has one,
   * and an absent value says so rather than naming an object that is not there.
   *
   * @generated from field: optional bytes avatar_media_id = 4;
   */
  avatarMediaId?: Uint8Array | undefined;

  /**
   * Advances when the display name or avatar changes, so a client can cache an
   * identity and know when the cached copy is stale.
   *
   * @generated from field: int64 profile_version = 5;
   */
  profileVersion: bigint;
};

/**
 * Describes the message chat.v1.SenderIdentity.
 * Use `create(SenderIdentitySchema)` to create a new message.
 */
export const SenderIdentitySchema: GenMessage<SenderIdentity> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 8);

/**
 * @generated from message chat.v1.Conversation
 */
export type Conversation = Message$1<"chat.v1.Conversation"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: chat.v1.Conversation.Kind kind = 2;
   */
  kind: Conversation_Kind;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: int64 head_seq = 4;
   */
  headSeq: bigint;

  /**
   * @generated from field: int64 policy_version = 5;
   */
  policyVersion: bigint;

  /**
   * @generated from field: chat.v1.Conversation.HistoryPolicy history_policy = 6;
   */
  historyPolicy: Conversation_HistoryPolicy;

  /**
   * @generated from field: chat.v1.Conversation.DeliveryMode delivery_mode = 7;
   */
  deliveryMode: Conversation_DeliveryMode;

  /**
   * @generated from field: string own_role = 8;
   */
  ownRole: string;

  /**
   * @generated from field: uint32 unread_count = 9;
   */
  unreadCount: number;

  /**
   * Set when the exact unread count is too expensive to compute for this
   * conversation. A capped count is an estimate and is presented as one.
   *
   * @generated from field: bool unread_capped = 10;
   */
  unreadCapped: boolean;

  /**
   * The conversation photo, when one is set. Absent means none: a client falls
   * back to generated initials rather than to a placeholder image it would have
   * to download.
   *
   * @generated from field: optional bytes photo_media_id = 11;
   */
  photoMediaId?: Uint8Array | undefined;
};

/**
 * Describes the message chat.v1.Conversation.
 * Use `create(ConversationSchema)` to create a new message.
 */
export const ConversationSchema: GenMessage<Conversation> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 9);

/**
 * @generated from enum chat.v1.Conversation.Kind
 */
export enum Conversation_Kind {
  /**
   * @generated from enum value: KIND_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: KIND_DIRECT = 1;
   */
  DIRECT = 1,

  /**
   * @generated from enum value: KIND_SAVED = 2;
   */
  SAVED = 2,

  /**
   * @generated from enum value: KIND_GROUP = 3;
   */
  GROUP = 3,

  /**
   * @generated from enum value: KIND_CHANNEL = 4;
   */
  CHANNEL = 4,

  /**
   * @generated from enum value: KIND_CHANNEL_INBOX = 5;
   */
  CHANNEL_INBOX = 5,
}

/**
 * Describes the enum chat.v1.Conversation.Kind.
 */
export const Conversation_KindSchema: GenEnum<Conversation_Kind> = /*@__PURE__*/
  enumDesc(file_chat_v1_common, 9, 0);

/**
 * @generated from enum chat.v1.Conversation.HistoryPolicy
 */
export enum Conversation_HistoryPolicy {
  /**
   * @generated from enum value: HISTORY_POLICY_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: HISTORY_POLICY_ALL_HISTORY = 1;
   */
  ALL_HISTORY = 1,

  /**
   * @generated from enum value: HISTORY_POLICY_SINCE_JOIN = 2;
   */
  SINCE_JOIN = 2,
}

/**
 * Describes the enum chat.v1.Conversation.HistoryPolicy.
 */
export const Conversation_HistoryPolicySchema: GenEnum<Conversation_HistoryPolicy> = /*@__PURE__*/
  enumDesc(file_chat_v1_common, 9, 1);

/**
 * @generated from enum chat.v1.Conversation.DeliveryMode
 */
export enum Conversation_DeliveryMode {
  /**
   * @generated from enum value: DELIVERY_MODE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: DELIVERY_MODE_PUSH = 1;
   */
  PUSH = 1,

  /**
   * @generated from enum value: DELIVERY_MODE_PULL = 2;
   */
  PULL = 2,
}

/**
 * Describes the enum chat.v1.Conversation.DeliveryMode.
 */
export const Conversation_DeliveryModeSchema: GenEnum<Conversation_DeliveryMode> = /*@__PURE__*/
  enumDesc(file_chat_v1_common, 9, 2);

/**
 * @generated from message chat.v1.Draft
 */
export type Draft = Message$1<"chat.v1.Draft"> & {
  /**
   * @generated from field: chat.v1.Content content = 1;
   */
  content?: Content | undefined;

  /**
   * @generated from field: int64 version = 2;
   */
  version: bigint;

  /**
   * @generated from field: int64 updated_at = 3;
   */
  updatedAt: bigint;

  /**
   * Uploads that have not reached READY yet. A draft may reference them;
   * sending may not, and they create no durable media reference.
   *
   * @generated from field: repeated bytes pending_upload_ids = 4;
   */
  pendingUploadIds: Uint8Array[];
};

/**
 * Describes the message chat.v1.Draft.
 * Use `create(DraftSchema)` to create a new message.
 */
export const DraftSchema: GenMessage<Draft> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 10);

/**
 * @generated from message chat.v1.Dialog
 */
export type Dialog = Message$1<"chat.v1.Dialog"> & {
  /**
   * @generated from field: chat.v1.Conversation conversation = 1;
   */
  conversation?: Conversation | undefined;

  /**
   * @generated from field: optional chat.v1.Message last_message = 2;
   */
  lastMessage?: Message | undefined;

  /**
   * @generated from field: optional chat.v1.Draft draft = 3;
   */
  draft?: Draft | undefined;

  /**
   * @generated from field: int64 last_read_seq = 4;
   */
  lastReadSeq: bigint;

  /**
   * @generated from field: optional int64 muted_until = 5;
   */
  mutedUntil?: bigint | undefined;

  /**
   * @generated from field: bool archived = 6;
   */
  archived: boolean;
};

/**
 * Describes the message chat.v1.Dialog.
 * Use `create(DialogSchema)` to create a new message.
 */
export const DialogSchema: GenMessage<Dialog> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 11);

/**
 * @generated from message chat.v1.Member
 */
export type Member = Message$1<"chat.v1.Member"> & {
  /**
   * @generated from field: bytes user_id = 1;
   */
  userId: Uint8Array;

  /**
   * @generated from field: chat.v1.Member.Role role = 2;
   */
  role: Member_Role;

  /**
   * @generated from field: int64 permissions = 3;
   */
  permissions: bigint;

  /**
   * @generated from field: int64 joined_seq = 4;
   */
  joinedSeq: bigint;

  /**
   * @generated from field: bool banned = 5;
   */
  banned: boolean;
};

/**
 * Describes the message chat.v1.Member.
 * Use `create(MemberSchema)` to create a new message.
 */
export const MemberSchema: GenMessage<Member> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 12);

/**
 * @generated from enum chat.v1.Member.Role
 */
export enum Member_Role {
  /**
   * @generated from enum value: ROLE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: ROLE_OWNER = 1;
   */
  OWNER = 1,

  /**
   * @generated from enum value: ROLE_ADMIN = 2;
   */
  ADMIN = 2,

  /**
   * @generated from enum value: ROLE_MEMBER = 3;
   */
  MEMBER = 3,

  /**
   * @generated from enum value: ROLE_RESTRICTED = 4;
   */
  RESTRICTED = 4,
}

/**
 * Describes the enum chat.v1.Member.Role.
 */
export const Member_RoleSchema: GenEnum<Member_Role> = /*@__PURE__*/
  enumDesc(file_chat_v1_common, 12, 0);

/**
 * Event is one entry in a stream. The body is the encoded resource named by
 * event_type; there is no untyped JSON anywhere in this protocol.
 *
 * @generated from message chat.v1.Event
 */
export type Event = Message$1<"chat.v1.Event"> & {
  /**
   * @generated from field: bytes event_id = 1;
   */
  eventId: Uint8Array;

  /**
   * @generated from field: string stream_id = 2;
   */
  streamId: string;

  /**
   * @generated from field: int64 seq = 3;
   */
  seq: bigint;

  /**
   * @generated from field: bytes entity_id = 4;
   */
  entityId: Uint8Array;

  /**
   * @generated from field: int64 entity_version = 5;
   */
  entityVersion: bigint;

  /**
   * @generated from field: uint32 event_type = 6;
   */
  eventType: number;

  /**
   * @generated from field: bytes body = 7;
   */
  body: Uint8Array;
};

/**
 * Describes the message chat.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 13);

/**
 * Difference is a page of changes.
 *
 * scanned_through is what makes filtered history safe: a page may legitimately
 * omit events the caller is not allowed to see, and this boundary confirms
 * those positions were considered under the caller's visibility policy rather
 * than lost. A client must not re-request them as if they were dropped packets.
 *
 * @generated from message chat.v1.Difference
 */
export type Difference = Message$1<"chat.v1.Difference"> & {
  /**
   * @generated from field: repeated chat.v1.Event events = 1;
   */
  events: Event[];

  /**
   * @generated from field: bytes next_cursor = 2;
   */
  nextCursor: Uint8Array;

  /**
   * @generated from field: int64 scanned_through = 3;
   */
  scannedThrough: bigint;

  /**
   * @generated from field: int64 head = 4;
   */
  head: bigint;

  /**
   * @generated from field: bool has_more = 5;
   */
  hasMore: boolean;
};

/**
 * Describes the message chat.v1.Difference.
 * Use `create(DifferenceSchema)` to create a new message.
 */
export const DifferenceSchema: GenMessage<Difference> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 14);

/**
 * @generated from message chat.v1.PageInfo
 */
export type PageInfo = Message$1<"chat.v1.PageInfo"> & {
  /**
   * @generated from field: optional bytes next_cursor = 1;
   */
  nextCursor?: Uint8Array | undefined;

  /**
   * @generated from field: bool has_more = 2;
   */
  hasMore: boolean;
};

/**
 * Describes the message chat.v1.PageInfo.
 * Use `create(PageInfoSchema)` to create a new message.
 */
export const PageInfoSchema: GenMessage<PageInfo> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 15);

/**
 * @generated from message chat.v1.Profile
 */
export type Profile = Message$1<"chat.v1.Profile"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string bio = 3;
   */
  bio: string;

  /**
   * @generated from field: optional string username = 4;
   */
  username?: string | undefined;

  /**
   * @generated from field: optional bytes photo_media_id = 5;
   */
  photoMediaId?: Uint8Array | undefined;

  /**
   * @generated from field: optional string birthday = 6;
   */
  birthday?: string | undefined;

  /**
   * @generated from field: string birthday_visibility = 7;
   */
  birthdayVisibility: string;

  /**
   * @generated from field: optional bytes music_media_id = 8;
   */
  musicMediaId?: Uint8Array | undefined;

  /**
   * @generated from field: int64 version = 9;
   */
  version: bigint;
};

/**
 * Describes the message chat.v1.Profile.
 * Use `create(ProfileSchema)` to create a new message.
 */
export const ProfileSchema: GenMessage<Profile> = /*@__PURE__*/
  messageDesc(file_chat_v1_common, 16);

